import RoundingAnimationDarkJson from 'assets/ver2/lotties/calculator-rounding-animation-dark.json';
import RoundingAnimationWhiteJson from 'assets/ver2/lotties/calculator-rounding-animation-white.json';
import Lottie from 'lottie-react';
import React from 'react';

const CalculatorRoundingAnimationLottie = ({
  mode,
  width = '20.5px',
  height = '20.5px',
}) => {
  return (
    <Lottie
      animationData={
        mode === 'dark' ? RoundingAnimationDarkJson : RoundingAnimationWhiteJson
      }
      loop={true}
      style={{
        width,
        height,
      }}
    />
  );
};

export default CalculatorRoundingAnimationLottie;
